import { Instagram, Mail } from "lucide-react";
import { Mark } from "@/components/torq/Logo";

const SOCIALS = [
  { icon: Instagram, label: "instagram", href: "https://www.instagram.com/torqcircuit/" },
  { icon: Mail, label: "mail", href: "mailto:info@torqcircuit.com" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden" data-testid="footer">
      <div className="px-6 lg:px-12 pt-16 pb-10 flex flex-col lg:flex-row justify-between gap-10">
        <div>
          <img
            src="/logo-long.png"
            alt="TORQ Circuit"
            className="h-9 w-auto"
            data-testid="footer-logo"
          />
          <p className="mt-4 font-mono text-[11px] tracking-[0.25em] text-[#6e6e6a]" data-testid="footer-tagline">
            THE HYBRID FITNESS RACE — DELHI, INDIA
          </p>
        </div>
        <div className="flex items-start gap-3" data-testid="footer-socials">
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              aria-label={s.label}
              data-testid={`footer-social-${s.label}`}
              target={s.href.startsWith("http") ? "_blank" : undefined}
              rel={s.href.startsWith("http") ? "noopener noreferrer" : undefined}
              className="border border-[#2e2e2a] p-3 text-[#a3a39f] hover:bg-[#f0eee4] hover:text-[#161614] hover:border-[#f0eee4] transition-colors"
            >
              <s.icon size={16} />
            </a>
          ))}
        </div>
      </div>

      <div className="overflow-hidden flex justify-center" data-testid="footer-wordmark">
        <img
          src="/logo-long.png"
          alt=""
          aria-hidden="true"
          className="w-[86vw] max-w-none translate-y-[12%] opacity-[0.09] select-none pointer-events-none"
        />
      </div>

      <div className="px-6 lg:px-12 py-5 border-t border-[#2e2e2a] flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] tracking-[0.2em] text-[#6e6e6a]">
        <p data-testid="footer-copyright">© {year} TORQ CIRCUIT — ALL RIGHTS RESERVED</p>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 sm:justify-end" data-testid="footer-legal">
          <a href="/partners" data-testid="footer-legal-partners" className="hover:text-[#f0eee4] transition-colors">BECOME A PARTNER</a>
          <a href="/officials" data-testid="footer-legal-officials" className="hover:text-[#f0eee4] transition-colors">BECOME AN OFFICIAL</a>
          <a href="/terms" data-testid="footer-legal-terms" className="hover:text-[#f0eee4] transition-colors">TERMS & CONDITIONS</a>
          <a href="/refund-policy" data-testid="footer-legal-refund" className="hover:text-[#f0eee4] transition-colors">REFUND POLICY</a>
          <a href="/privacy-policy" data-testid="footer-legal-privacy" className="hover:text-[#f0eee4] transition-colors">PRIVACY POLICY</a>
        </nav>
      </div>
    </footer>
  );
}
